module.exports = __webpack_public_path__ + "static/resumer-building-25c606d620ce76b41e590ee892e6ae4a.jpg";